import { createContext, useContext } from "react";
import { Language } from '../../interfaces/language';

export type LanguageContextProps = {
    translations: Language
};

export const LanguageContext = createContext<LanguageContextProps>({} as LanguageContextProps)

const useTranslations = () => {
    const languageContext = useContext(LanguageContext);

    return languageContext.translations;
}

export default useTranslations;
